import styled from '@emotion/styled'
import { MediaQueries } from '@hhgtech/hhg-components'

export const StyledExpertSection = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-auto-rows: 1fr;
  grid-auto-flow: dense;
  gap: 24px 24px;
  grid-template-areas: '. .  a a';
  direction: rtl;
  .header {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-right: 32px;
    grid-area: a;
    direction: ltr;
  }
  .description {
    white-space: pre-line;
  }
  ${MediaQueries.mbDown} {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 0;
    .header {
      margin-right: 0;
    }
  }
`

export const StyledSeeMore = styled.a`
  display: flex;
  align-items: center;
  gap: 4px;
`
